/**
 * Opens the OS file chooser for a file input.
 * Touch + WebKit/Chromium often receive pointer/click on the host input while the default
 * native "Choose file" control does not open; showPicker() or a same-gesture programmatic click fixes that.
 */
export function openNativeFilePicker(input: HTMLInputElement | null): void {
  if (!input) return
  const showPicker = (input as HTMLInputElement & { showPicker?: () => void | Promise<void> }).showPicker
  if (typeof showPicker === 'function') {
    try {
      const result = showPicker.call(input)
      if (result != null && typeof (result as Promise<void>).then === 'function') {
        void (result as Promise<void>).catch(() => {
          input.click()
        })
      }
    } catch {
      input.click()
    }
    return
  }
  input.click()
}
